function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor"
}, React.createElement("path", {
  d: "M0 0h4v4H0zM6 0h4v4H6zM16 0h-4v4h4zM0 6h4v4H0zM10 6H6v4h4zM12 6h4v4h-4zM4 12H0v4h4zM6 12h4v4H6zM16 12h-4v4h4z"
}));

var SvgGrid = function SvgGrid(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 16
  }, props), _ref);
};

export default SvgGrid;